<script setup lang="ts">
import { toRef } from "vue";

const props = defineProps<{
  historicOpen: boolean;
}>();

const showMore = toRef(props, "historicOpen");

const emit = defineEmits<{
  (e: "update:historicOpen", value: boolean): void;
}>();

const handleShowMore = () => {
  emit("update:historicOpen", !showMore.value);
};
</script>
<template>
  <div class="text-center mt-3">
    <el-button type="text" class="show-more" @click="handleShowMore">Ver histórico</el-button>
  </div>
</template>
<style lang="scss" scoped>
::v-deep .show-more {
  color: #aaa !important;
}
::v-deep .show-more:hover,
::v-deep .show-more:focus {
  color: #555 !important;
  text-decoration: underline;
}
</style>
